/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  EMPTY_INTRANET_TASK_PROGRESS,
  EMPTY_XERO_SYNC_PROGRESS, IntranetManagerContractsUpdateBulkJobDto,
  SystemVarsAccountsIntranetDto,
  SystemVarsAccountsTwilioDto,
  SystemVarsAccountsXeroDto,
  SystemVarsAccountsXeroOauth1Dto,
  SystemVarsAccountsXeroSyncDto,
  SystemVarsAccountsXeroUrlDto,
  XeroSyncProgressDto,
} from '@gh/builder-shared-data';
import { mergeWithPrivelegedTokens } from '@gh/core-data';

export type SystemVarsAccountsTwilio = SystemVarsAccountsTwilioDto;
export type SystemVarsAccountsIntranet = SystemVarsAccountsIntranetDto;
export type WithXeroSyncProgress<T> = T & {
  progress: SystemVarsAccountsXeroSyncProgress;
};
export type WithIntranetTaskProgress = {
  progress: SystemVarsAccountsIntranetTaskProgress;
};
export type SystemVarsAccountsXeroOauth1 = WithXeroSyncProgress<SystemVarsAccountsXeroOauth1Dto>;
export type SystemVarsAccountsXero = WithXeroSyncProgress<SystemVarsAccountsXeroDto>;
export type SystemVarsAccountsXeroSyncProgress = XeroSyncProgressDto;
export type SystemVarsAccountsXeroUrl = SystemVarsAccountsXeroUrlDto;
export type SystemVarsAccountsXeroSync = SystemVarsAccountsXeroSyncDto;
export type SystemVarsAccountsIntranetTaskProgress = IntranetManagerContractsUpdateBulkJobDto;

export function systemVarsAccountsXeroToDto(model: SystemVarsAccountsXero): SystemVarsAccountsXeroDto {
  return <SystemVarsAccountsXeroDto>{
    ...model,
    etag: model.etag,
    privilegedTokens: mergeWithPrivelegedTokens(model),
  };
}

// tslint:disable-next-line:max-line-length
export const getXeroSyncProgress = (settings: SystemVarsAccountsXeroOauth1) => settings.progress || EMPTY_XERO_SYNC_PROGRESS;

export const isXeroSyncInProgress = (progress: SystemVarsAccountsXeroSyncProgress) =>
  progress.initialSyncInProgress || progress.syncInProgress;

export const getIntranetTaskProgress = (settings: SystemVarsAccountsIntranetTaskProgress) =>
  settings.isTaskInProgress || EMPTY_INTRANET_TASK_PROGRESS;

export const isIntranetTaskInProgress = (progress: SystemVarsAccountsIntranetTaskProgress) =>
  progress.isTaskInProgress;
